import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sx" }
const _hoisted_2 = { class: "sx-head tr-head" }
const _hoisted_3 = {
  class: "sx-card",
  "aria-labelledby": "tr-list-title"
}
const _hoisted_4 = { class: "sx-list-head" }
const _hoisted_5 = { id: "tr-list-title" }
const _hoisted_6 = { class: "sx-count" }
const _hoisted_7 = { class: "sx-search" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "sx-load-error",
  role: "alert"
}
const _hoisted_10 = {
  key: 2,
  class: "sx-empty"
}
const _hoisted_11 = {
  key: 3,
  class: "sx-rows"
}
const _hoisted_12 = {
  class: "sx-avatar",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "sx-main" }
const _hoisted_14 = {
  key: 0,
  class: "sx-code"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "sx-meta" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "sx-tag" }
const _hoisted_19 = { class: "sx-tag" }
const _hoisted_20 = { class: "sx-actions" }
const _hoisted_21 = ["aria-label", "title", "onClick"]
const _hoisted_22 = ["aria-label", "onClick"]
const _hoisted_23 = ["aria-label", "title", "disabled", "onClick"]
const _hoisted_24 = {
  id: "transportModal",
  ref: "modalEl",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "transportModalLabel",
  "aria-hidden": "true"
}
const _hoisted_25 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" }
const _hoisted_26 = { class: "modal-header" }
const _hoisted_27 = {
  id: "transportModalLabel",
  class: "modal-title"
}
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = { class: "sx-field" }
const _hoisted_30 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_31 = { class: "sx-field" }
const _hoisted_32 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_33 = { class: "sx-field" }
const _hoisted_34 = ["aria-checked", "onClick"]
const _hoisted_35 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_36 = {
  key: 1,
  class: "sx-help"
}
const _hoisted_37 = { class: "sx-field" }
const _hoisted_38 = {
  key: 0,
  class: "tr-zones",
  role: "table",
  "aria-labelledby": "tr-zones"
}
const _hoisted_39 = {
  class: "tr-zrow tr-zhead",
  role: "row"
}
const _hoisted_40 = { role: "columnheader" }
const _hoisted_41 = { role: "cell" }
const _hoisted_42 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_43 = { role: "cell" }
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = ["onUpdate:modelValue", "aria-label", "onInput"]
const _hoisted_46 = { class: "input-group-text" }
const _hoisted_47 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_48 = { role: "cell" }
const _hoisted_49 = ["aria-label", "onClick"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 1,
  class: "sx-err"
}
const _hoisted_52 = {
  key: 2,
  class: "sx-help"
}
const _hoisted_53 = {
  key: 3,
  class: "sx-help tr-legacy"
}
const _hoisted_54 = {
  key: 4,
  class: "sx-help"
}
const _hoisted_55 = { class: "sx-field mb-0" }
const _hoisted_56 = { class: "form-check form-switch tr-switch" }
const _hoisted_57 = {
  class: "form-check-label",
  for: "tr-active"
}
const _hoisted_58 = { class: "modal-footer" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", null, [
        _createElementVNode("span", { class: "sx-eyebrow" }, "Transport"),
        _createElementVNode("h1", { class: "sx-title" }, "Transports"),
        _createElementVNode("p", { class: "sx-sub" }, "Transporteurs utilisés pour les bons d'envoi et les bons de retour, avec leur tarif par sac pour chaque zone desservie.")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary tr-add",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal(null)))
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("i", {
          class: "ph ph-plus",
          "aria-hidden": "true"
        }, null, -1),
        _createTextVNode(" Nouveau transport ", -1)
      ]))
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, [
          _cache[12] || (_cache[12] = _createTextVNode("Transports ", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.transports.length), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("i", {
            class: "ph ph-magnifying-glass",
            "aria-hidden": "true"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
            type: "search",
            placeholder: "Rechercher un transport…",
            "aria-label": "Rechercher un transport"
          }, null, 512), [
            [_vModelText, _ctx.search]
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
              return _createElementVNode("span", {
                key: n,
                class: "sx-skel"
              })
            }), 64))
          ]))
        : (_ctx.loadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[14] || (_cache[14] = _createElementVNode("i", {
                class: "ph ph-warning-circle",
                "aria-hidden": "true"
              }, null, -1)),
              _cache[15] || (_cache[15] = _createTextVNode(" Impossible de charger les transports. ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fetchtransports && _ctx.fetchtransports(...args)))
              }, "Réessayer")
            ]))
          : (!_ctx.filtered.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[16] || (_cache[16] = _createElementVNode("i", {
                  class: "ph ph-truck",
                  "aria-hidden": "true"
                }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.search ? "Aucun transport ne correspond à votre recherche." : "Aucun transport pour le moment."), 1)
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.id,
                    class: _normalizeClass(["sx-row", { 'is-new': item.id === _ctx.lastAddedId }])
                  }, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.initials(item.name)), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                      _createElementVNode("small", null, [
                        (item.code_transport)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.code_transport), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, "Sans code"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sx-tag", _ctx.isActive(item) ? 'tone-success' : 'tone-danger'])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["ph", _ctx.isActive(item) ? 'ph-check-circle' : 'ph-x-circle']),
                          "aria-hidden": "true"
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(_ctx.isActive(item) ? "Actif" : "Inactif"), 1)
                      ], 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(["sx-tag", _ctx.zonesOf(item).length ? 'tone-accent' : '']),
                        title: _ctx.zonesOf(item).length ? _ctx.zonesTitle(item) : 'Aucune zone : frais saisis à l\'expédition'
                      }, [
                        _cache[17] || (_cache[17] = _createElementVNode("i", {
                          class: "ph ph-map-trifold",
                          "aria-hidden": "true"
                        }, null, -1)),
                        (_ctx.zonesOf(item).length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.zonesOf(item).length), 1),
                              _createTextVNode(" zone(s) · " + _toDisplayString(_ctx.priceRange(item)) + " / sac", 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Sans tarif")
                            ], 64))
                      ], 10, _hoisted_17),
                      (_ctx.typeOf(item.type))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["sx-tag", String(item.type) === '1' ? 'tone-accent' : 'tone-info'])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["ph", _ctx.typeOf(item.type)?.icon]),
                              "aria-hidden": "true"
                            }, null, 2),
                            _createTextVNode(_toDisplayString(_ctx.typeOf(item.type)?.label), 1)
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_18, [
                        _cache[18] || (_cache[18] = _createElementVNode("i", {
                          class: "ph ph-paper-plane-tilt",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.num(item.bons)), 1),
                        _cache[19] || (_cache[19] = _createTextVNode(" bon(s) d'envoi", -1))
                      ]),
                      _createElementVNode("span", _hoisted_19, [
                        _cache[20] || (_cache[20] = _createElementVNode("i", {
                          class: "ph ph-arrow-u-up-left",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.num(item.bonsRN)), 1),
                        _cache[21] || (_cache[21] = _createTextVNode(" bon(s) retour", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "sx-icon-btn",
                        "aria-label": _ctx.isActive(item) ? `Désactiver ${item.name}` : `Activer ${item.name}`,
                        title: _ctx.isActive(item) ? 'Désactiver' : 'Activer',
                        onClick: ($event: any) => (_ctx.toggleActive(item))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["ph", _ctx.isActive(item) ? 'ph-toggle-right' : 'ph-toggle-left']),
                          "aria-hidden": "true"
                        }, null, 2)
                      ], 8, _hoisted_21),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sx-icon-btn",
                        "aria-label": `Modifier ${item.name}`,
                        title: "Modifier",
                        onClick: ($event: any) => (_ctx.openModal(item))
                      }, _cache[22] || (_cache[22] = [
                        _createElementVNode("i", {
                          class: "ph ph-pencil-simple",
                          "aria-hidden": "true"
                        }, null, -1)
                      ]), 8, _hoisted_22),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sx-icon-btn is-danger",
                        "aria-label": `Supprimer ${item.name}`,
                        title: _ctx.isUsed(item) ? 'Impossible : transport utilisé par des bons' : 'Supprimer',
                        disabled: _ctx.isUsed(item),
                        onClick: ($event: any) => (_ctx.deleteType(item.id))
                      }, _cache[23] || (_cache[23] = [
                        _createElementVNode("i", {
                          class: "ph ph-trash",
                          "aria-hidden": "true"
                        }, null, -1)
                      ]), 8, _hoisted_23)
                    ])
                  ], 2))
                }), 128))
              ]))
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("form", {
          class: "modal-content",
          novalidate: "",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.form.id ? "Modifier le transport" : "Nouveau transport"), 1),
            _cache[24] || (_cache[24] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { for: "tr-name" }, [
                _createTextVNode("Nom du transport "),
                _createElementVNode("span", {
                  class: "sx-req",
                  "aria-hidden": "true"
                }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "tr-name",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
                maxlength: "100",
                placeholder: "Ex. CTM Messagerie",
                onInput: _cache[4] || (_cache[4] = ($event: any) => (delete _ctx.errors.name))
              }, null, 34), [
                [_vModelText, _ctx.form.name]
              ]),
              (_ctx.errors.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.errors.name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { for: "tr-code" }, "Code du transport", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "tr-code",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.code_transport) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.code_transport }]),
                maxlength: "50",
                placeholder: "Ex. CTM",
                onInput: _cache[6] || (_cache[6] = ($event: any) => (delete _ctx.errors.code_transport))
              }, null, 34), [
                [_vModelText, _ctx.form.code_transport]
              ]),
              (_ctx.errors.code_transport)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.errors.code_transport), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { id: "tr-type" }, [
                _createTextVNode("Type "),
                _createElementVNode("span", {
                  class: "sx-req",
                  "aria-hidden": "true"
                }, "*")
              ], -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["sx-seg", { 'is-invalid': _ctx.errors.type }]),
                role: "radiogroup",
                "aria-labelledby": "tr-type"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (opt) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: opt.value,
                    type: "button",
                    role: "radio",
                    "aria-checked": _ctx.form.type === opt.value,
                    class: _normalizeClass({ 'is-active': _ctx.form.type === opt.value }),
                    onClick: ($event: any) => {_ctx.form.type = opt.value; delete _ctx.errors.type}
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["ph", opt.icon]),
                      "aria-hidden": "true"
                    }, null, 2),
                    _createTextVNode(_toDisplayString(opt.label), 1)
                  ], 10, _hoisted_34))
                }), 128))
              ], 2),
              (_ctx.errors.type)
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.errors.type), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_36, "Interne : votre propre flotte. Externe : transporteur partenaire."))
            ]),
            _createElementVNode("div", _hoisted_37, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { id: "tr-zones" }, "Zones et tarifs par sac", -1)),
              _cache[35] || (_cache[35] = _createElementVNode("span", { class: "sx-help tr-zones-sub" }, "Sélectionnez les zones desservies et définissez un tarif par sac pour chaque zone.", -1)),
              (_ctx.form.zones.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[28] || (_cache[28] = _createElementVNode("span", { role: "columnheader" }, "Zone", -1)),
                      _createElementVNode("span", _hoisted_40, "Tarif par sac (" + _toDisplayString(_ctx.$devis) + ")", 1),
                      _cache[29] || (_cache[29] = _createElementVNode("span", { role: "columnheader" }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Actions")
                      ], -1))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.zones, (z, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: z.key,
                        class: "tr-zrow",
                        role: "row"
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_v_select, {
                            modelValue: z.zone_id,
                            "onUpdate:modelValue": ($event: any) => ((z.zone_id) = $event),
                            class: _normalizeClass(["tr-vselect", { 'is-invalid': _ctx.errors[`zones.${i}.zone_id`] }]),
                            label: "name",
                            options: _ctx.zoneOptions(i),
                            reduce: (opt) => opt.id,
                            clearable: false,
                            placeholder: "Choisir une zone...",
                            "input-id": `tr-zone-${i}`,
                            "onOption:selected": ($event: any) => (delete _ctx.errors[`zones.${i}.zone_id`])
                          }, {
                            "no-options": _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode("Aucune zone trouvée", -1)
                            ])),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "class", "options", "reduce", "input-id", "onOption:selected"]),
                          (_ctx.errors[`zones.${i}.zone_id`])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.errors[`zones.${i}.zone_id`]), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((z.price_per_bag) = $event),
                              type: "number",
                              min: "0",
                              step: "0.01",
                              inputmode: "decimal",
                              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors[`zones.${i}.price_per_bag`] }]),
                              placeholder: "Saisir le tarif",
                              "aria-label": `Tarif par sac de la ligne ${i + 1}`,
                              onInput: ($event: any) => (delete _ctx.errors[`zones.${i}.price_per_bag`])
                            }, null, 42, _hoisted_45), [
                              [_vModelText, z.price_per_bag]
                            ]),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$devis), 1)
                          ]),
                          (_ctx.errors[`zones.${i}.price_per_bag`])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.errors[`zones.${i}.price_per_bag`]), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "tr-zdel",
                            "aria-label": `Retirer la ligne ${i + 1}`,
                            title: "Retirer",
                            onClick: ($event: any) => (_ctx.removeZone(i))
                          }, _cache[31] || (_cache[31] = [
                            _createElementVNode("i", {
                              class: "ph ph-trash",
                              "aria-hidden": "true"
                            }, null, -1)
                          ]), 8, _hoisted_49)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn tr-zadd",
                disabled: !_ctx.canAddZone,
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addZone && _ctx.addZone(...args)))
              }, _cache[32] || (_cache[32] = [
                _createElementVNode("i", {
                  class: "ph ph-plus",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode(" Ajouter une zone ", -1)
              ]), 8, _hoisted_50),
              (_ctx.zonesError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.zonesError), 1))
                : (!_ctx.form.zones.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Sans zone, les frais de transport sont saisis à l'expédition."))
                  : _createCommentVNode("", true),
              (_ctx.form.legacyPrice !== null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                    _cache[33] || (_cache[33] = _createElementVNode("i", {
                      class: "ph ph-info",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(" Ancien tarif unique : " + _toDisplayString(_ctx.money(_ctx.form.legacyPrice)) + " / sac. Il sera remplacé par les tarifs par zone à l'enregistrement. ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_54, "S'applique aux prochaines expéditions ; les bons déjà expédiés gardent leurs frais."))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_55, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { for: "tr-active" }, "Statut", -1)),
              _createElementVNode("div", _hoisted_56, [
                _withDirectives(_createElementVNode("input", {
                  id: "tr-active",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.active) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  role: "switch"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.active]
                ]),
                _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.form.active ? "Actif" : "Inactif"), 1)
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("span", { class: "sx-help" }, "Un transport inactif n'est plus proposé à l'expédition des bons.", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _cache[38] || (_cache[38] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              disabled: _ctx.saving
            }, [
              (_ctx.saving)
                ? (_openBlock(), _createElementBlock("span", _hoisted_60))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.form.id ? "Enregistrer" : "Ajouter le transport"), 1)
            ], 8, _hoisted_59)
          ])
        ], 32)
      ])
    ], 512)
  ]))
}